<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <tran-pill-table aria-hidden="true">
            <tran-pill-header-row rowClasses="min-h-[20px]" class="!font-normal !text-sm text-secondary">
                <tran-pill-header-cell bgColor="bg-transparent">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-header-cell>
                <tran-pill-header-cell bgColor="bg-transparent">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-header-cell>
            </tran-pill-header-row>
            <tran-pill-row rowClasses="min-h-[44px]">
                <tran-pill-cell bgColor="bg-deep-blue-750">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-cell>
                <tran-pill-cell bgColor="bg-deep-blue-800">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-cell>
            </tran-pill-row>
        </tran-pill-table>
    } @else if (readonly()) {
        <tran-pill-table>
            <tran-pill-header-row rowClasses="min-h-[20px]" class="!font-normal !text-sm text-secondary">
                <tran-pill-header-cell bgColor="bg-transparent">
                    {{ 'components.application-detail-dashboard.application-detail-deadlines.start-date' | translate }}
                </tran-pill-header-cell>
                <tran-pill-header-cell bgColor="bg-transparent">
                    {{ 'components.application-detail-dashboard.application-detail-deadlines.end-date' | translate }}
                </tran-pill-header-cell>
            </tran-pill-header-row>
            <tran-pill-row rowClasses="min-h-[44px]">
                <tran-pill-cell bgColor="bg-deep-blue-750">
                    <span class="p-1">{{ startDate() | date: 'MM.yyyy' }}</span>
                </tran-pill-cell>
                <tran-pill-cell bgColor="bg-deep-blue-800">
                    <span class="p-1">{{ endDate() | date: 'MM.yyyy' }}</span>
                </tran-pill-cell>
            </tran-pill-row>
        </tran-pill-table>
    } @else {
        <div>
            <label for="start-date-input" class="form-label">
                {{ 'components.application-detail-dashboard.application-detail-deadlines.start-date' | translate }}
            </label>
            <si-calendar-button class="w-full">
                <input
                    id="start-date-input"
                    type="text"
                    class="form-control"
                    [class.is-invalid]="startDateControl().hasError(dateOrderErrorKey) && startDateControl().touched"
                    [placeholder]="
                        'components.application-detail-dashboard.application-detail-deadlines.placeholder' | translate
                    "
                    siDatepicker
                    tranFirstDayOfMonth
                    [siDatepickerConfig]="{ dateFormat: 'MM.yyyy', onlyMonthSelection: true }"
                    [autoClose]="true"
                    [formControl]="startDateControl()"
                />
            </si-calendar-button>
        </div>

        <div>
            <label for="end-date-input" class="form-label">
                {{ 'components.application-detail-dashboard.application-detail-deadlines.end-date' | translate }}
            </label>
            <si-calendar-button class="w-full">
                <input
                    id="end-date-input"
                    type="text"
                    class="form-control"
                    [class.is-invalid]="endDateControl().hasError(dateOrderErrorKey) && endDateControl().touched"
                    [placeholder]="
                        'components.application-detail-dashboard.application-detail-deadlines.placeholder' | translate
                    "
                    siDatepicker
                    tranFirstDayOfMonth
                    [siDatepickerConfig]="{ dateFormat: 'MM.yyyy', onlyMonthSelection: true }"
                    [autoClose]="true"
                    [formControl]="endDateControl()"
                />
            </si-calendar-button>
        </div>

        @if (
            (startDateControl().touched || endDateControl().touched) &&
            (startDateControl().hasError(dateOrderErrorKey) || endDateControl().hasError(dateOrderErrorKey))
        ) {
            <div class="text-danger d-block">
                {{
                    'components.application-detail-dashboard.application-detail-deadlines.validation.start-before-end'
                        | translate
                }}
            </div>
        }
    }
</tran-application-detail-dashboard-box>
